import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {ConfirmationComponent} from "./confirmation.component";
import {DownloadComponent} from "./download.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';


@NgModule({
  declarations: [ConfirmationComponent,DownloadComponent],
  imports     : [ChartsModule, FlotModule,IboxtoolsModule,PeityModule,SparklineModule,JVectorMapModule],
  exports     : [ConfirmationComponent,DownloadComponent],
})
export class DprModule { }



// WEBPACK FOOTER //
// ./src/app/views/dpr/dpr.module.ts